export class TermsAndConditionModel {
    public languageId: number;
    public countryId: string;
}
  